import { DescriptionList, ProductTable } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const RenderServicePlanAppplicationSummary: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <ProductTable>
      <ProductTable.Section>
        <DescriptionList split>
          <DescriptionList.Group termText={t('applicationSummary:productTable:quoteNumber')}>
            <DescriptionList.Detail>235564765</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:servicePlanName')}>
            <DescriptionList.Detail>Service Plan Name</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:servicePlanDescription')}>
            <DescriptionList.Detail>Service Plan Description</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:paymentTerm')}>
            <DescriptionList.Detail>02.03.2026</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:paymentMethod')}>
            <DescriptionList.Detail>Monthly</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:monthlyPaymentAmount')}>
            <DescriptionList.Detail>€3000</DescriptionList.Detail>
          </DescriptionList.Group>
        </DescriptionList>
      </ProductTable.Section>
    </ProductTable>
  );
};
